import merchantSettingsApi from '../_api'
export default {
  /* -- Merchant Actions -- */

  fetchMerchants: async ({ getters, commit }) => {
    if (getters.isCalling) return
    try {
      commit('setIsCalling', true)
      const page = getters.currentPage

      const response = await merchantSettingsApi.getMerchants(page)
      const lastPage = Number.parseInt(
        response.headers['pagination-last-page']
      )
      const totalItems = Number.parseInt(
        response.headers['pagination-total-items']
      )
      commit('setMerchants', response.data)
      commit('setLastPage', lastPage)
      commit('setTotalItems', totalItems)
    } catch (error) {
      throw error
    } finally {
      commit('setIsCalling', false)
    }
  },
  fetchMerchant: async ({ commit }, merchantId) => {
    try {
      const response = await merchantSettingsApi.getMerchant(merchantId)

      commit('setCurrentMerchant', response.data)
    } catch (error) {
      throw error
    }
  },
  updateMerchant: async ({ getters, commit }, { merchantId, merchantData }) => {
    if (!merchantId || !merchantData || getters.isCalling) return
    try {
      commit('setIsCalling', true)

      const response = await merchantSettingsApi.putMerchant(
        merchantId,
        merchantData
      )
      commit('updateMerchant', response.data)
    } catch (error) {
      throw error
    } finally {
      commit('setIsCalling', false)
    }
  },
  createMerchant: async ({ getters, commit, dispatch }, { merchantData }) => {
    if (!merchantData || getters.isCalling) return
    try {
      commit('setIsCalling', true)

      const response = await merchantSettingsApi.postMerchant(
        merchantData
      )
      await dispatch('fetchMerchants')

      return response.data
    } catch (error) {
      throw error
    } finally {
      commit('setIsCalling', false)
    }
  },
  updateMerchantLogo: async (
    { getters, commit, dispatch },
    { merchantId, merchantLogo }
  ) => {
    if (!merchantId || !merchantLogo || getters.isCalling) return
    try {
      let logo = new FormData()
      logo.append('file', merchantLogo)

      commit('setIsCalling', true)
      const response = await merchantSettingsApi.putMerchantLogo(
        merchantId,
        logo
      )
      commit('updateMerchant', response.data)
      commit('setIsCalling', false)
      await dispatch('fetchMerchant', merchantId)
    } catch (error) {
      throw error
    } finally {
      commit('setIsCalling', false)
    }
  },

  /* - Activity Groups Actions - */

  fetchActivityGroups: async ({ getters, commit }) => {
    if (getters.isCalling) return
    try {
      commit('setIsCalling', true)
      const page = getters.currentPage

      const response = await merchantSettingsApi.getActivityGroups(page)
      const lastPage = Number.parseInt(
        response.headers['pagination-last-page']
      )
      const totalItems = Number.parseInt(
        response.headers['pagination-total-items']
      )
      commit('setActivityGroups', response.data)
      commit('setLastPage', lastPage)
      commit('setTotalItems', totalItems)
    } catch (error) {
      throw error
    } finally {
      commit('setIsCalling', false)
    }
  },
  fetchActivityGroup: async ({ commit }, activityGroupId) => {
    try {
      const response = await merchantSettingsApi.getActivityGroup(
        activityGroupId
      )
      commit('setCurrentActivityGroup', response.data)
    } catch (error) {
      throw error
    }
  },
  updateActivityGroupLogo: async (
    { getters, commit },
    { activityGroupId, activityGroupLogo }
  ) => {
    if (!activityGroupId || !activityGroupLogo || getters.isCalling) return
    try {
      let logo = new FormData()
      logo.append('file', activityGroupLogo)
      commit('setIsCalling', true)
      const response = await merchantSettingsApi.postActivityGroupLogo(activityGroupId, logo)
      commit('updateActivityGroup', response.data)
    } catch (error) {
      throw error
    } finally {
      commit('setIsCalling', false)
    }
  },
  nextPage ({ commit, getters }) {
    if (getters.isCalling) return
    commit('incrementCurrentPage')
  },
  clearStore ({ commit }) {
    commit('clearStoreData')
  }
}
